.empty-table{margin-bottom:3em}.allergies-submitted .allergy.ng-invalid,.reactions-submitted .reaction.ng-invalid{border:red 1px solid!important;border-radius:2px}
/*# sourceMappingURL=medical-device-add-edit.component-K3DOFLDM.css.map */
